/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  totalRecord: 0,
  isLoading: false,
  responseTime: 0,
  isError: false,
  msgError: '',
};
export const employeeAttendanceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.EMPLOYEE_ATTENDANCE + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.EMPLOYEE_ATTENDANCE + '_RESULT':
      return {
        ...state,
        data: action.result.data.data,
        totalRecord: action.result.data?.total_data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.EMPLOYEE_ATTENDANCE + '_RESET':
      return {
        ...state,
        data: action.result.data.data,
        totalRecord: action.result.data?.total_data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.EMPLOYEE_ATTENDANCE + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
        status: action.err?.response?.status
      };
    default:
      return state;
  }
};
